import axios from 'axios';
import {moment} from '../../react/config.js';

if (document.getElementById('firstPayment')) {
    getSubscribes();

    async function getSubscribes() {
        try {
            let response = await axios.get('/subscribe');
            window.subscribesInfo = response.data;

            if (isNaN(window.subscribeId)) {
                window.subscribeId = 1;
            }

            document.querySelectorAll('.cost__box')[window.subscribeId - 1].classList.add('cost__box--active');
            paymentRangeInput($('.payment-input'), 1, 24, 1);
            initFirstPayment();
            setSubscribeInfo(1);
        } catch (event) {
            console.dir(event);
        }
    }
}

function initFirstPayment() {

    toggleChangeSubscribe();
    payment();

    function toggleChangeSubscribe() {
        // if (checkChangeSubscribe()) {
        //     let $changeSubscribeForm = document.querySelector('.cost__grid');
        //     $changeSubscribeForm.classList.remove('cost__grid--disabled');
        //     window.subscribeChangeAvailable = true;
        //     toggleChangeSubscribeButtons();
        // }

        let $changeSubscribeForm = document.querySelector('.cost__grid');
        $changeSubscribeForm.classList.remove('cost__grid--disabled');
        window.subscribeChangeAvailable = true;
        toggleChangeSubscribeButtons();

        function checkChangeSubscribe() {
            if (window.subscribeChange === '') {
                return true;
            }

            let changeDate = moment(new Date(window.subscribeChange));
            let today = moment(new Date());
            let duration = moment.duration(today.diff(changeDate));

            return duration.asMonths() >= 1;
        }

        function toggleChangeSubscribeButtons() {
            let $wrapper = document.querySelector('.cost--change');

            let itemClass = 'cost__box';
            let itemActiveClass = 'cost__box--active';
            let subItemClass = 'cost__box-connect';
            let subItemActiveClass = 'cost__box-connect--active';

            let buttons = document.querySelectorAll('.cost__connect-send');
            let items = document.querySelectorAll(`.${itemClass}`);
            let subItems = document.querySelectorAll(`.${subItemClass}`);


            for (let $button of buttons) {
                $button.addEventListener('click', event => {
                    let $currentItem = event.target.closest('.' + itemClass);
                    let $currentSubItem = event.target.closest('.' + subItemClass);

                    if (!$currentSubItem.classList.contains(subItemActiveClass)) {
                        for (let $item of items) {

                            $item.classList.remove(itemActiveClass);
                        }

                        for (let $subItem of subItems) {
                            $subItem.classList.remove(subItemActiveClass);
                        }

                        $currentItem.classList.add(itemActiveClass);
                        $currentSubItem.classList.add(subItemActiveClass);
                        window.subscribeId = parseInt($button.dataset.subscribe);
                        updateInfo();
                    }

                    function updateInfo() {
                        let currentVal = $('.payment-input__item').slider("option", "value");
                        setSubscribeInfo(currentVal);
                    }
                });
            }
        }
    }

    function payment() {
        let $paymentButton = document.getElementById('firstPaymentModalButton');

        $paymentButton.addEventListener('click', () => {
            redirectPayment(window.subscribeId, window.fullPayment);
        });
    }
}

function setSubscribeInfo(month) {
    let cost;
    let $modalWrapper = document.getElementById('firstPaymentModal');

    window.subscribesInfo.find(subscribe => {
        if (subscribe.id === window.subscribeId) {
            cost = subscribe.price;
        }
    });
    let futureMonth;

    if (window.subscribeChange === '') {
        futureMonth = moment(new Date()).add(1, 'M').format('DD.MM.YYYY');
    } else {
        futureMonth = moment(window.subscribeChange).add(1, 'M').format('DD.MM.YYYY');
    }


    window.fullPayment = month * cost;
    $('.payment-input__header-number--duration .payment-input__header-number-item').text(month);
    $('.payment-input__header-number--payment .payment-input__header-number-item').text(window.fullPayment);
    $('.payment-input__header-title--current-rate').text($('.cost__box--active .cost__box-title-inner').text());

    const rentalPeriodMonths = window.jsTranslations.rentalPeriodMonths ? window.jsTranslations.rentalPeriodMonths : 'Срок аренды (месяцев):';
    const tariffTextPayments = window.jsTranslations.tariffTextPayments ? window.jsTranslations.tariffTextPayments : 'сумма оплаты';
    const willBePossibleToChangeTariff = window.jsTranslations.willBePossibleToChangeTariff ? window.jsTranslations.willBePossibleToChangeTariff : 'Изменить тариф можно будет не ранее';

    let modalHtml = `
        <div class="modal__subtitle">${rentalPeriodMonths} ${month}, ${tariffTextPayments} ${window.fullPayment}€</div>
        <div class="modal__subtitle">${document.querySelector('.cost__box--active .cost__box-title-inner').innerText}.</div>
        <div class="modal__subtitle">${willBePossibleToChangeTariff} ${futureMonth}.</div>
    `;

    $modalWrapper.innerHTML = '';
    $modalWrapper.innerHTML = modalHtml;
}

function paymentRangeInput($slider, minValue, maxValue, initValue, val_start_2) {
    let $sliderItem = $slider.find('.payment-input__item');

    $sliderItem.slider({
        min: minValue,
        max: maxValue,
        slide: function (event, ui) {
            setSubscribeInfo(ui.value);
        },
        create: function (event, ui) {
            document.getElementById('firstPaymentModalButton').disabled = false;
        },
        change: function (event, ui) {
        },
        value: initValue,
        classes: {
            "ui-slider": "ui-corner-all range-slider__item-line",
            "ui-slider-handle": "ui-corner-all range-slider__item-handle",
            "ui-slider-range": "ui-corner-all ui-widget-header range-slider__item-progress"
        }
    });
}

function redirectPayment(subscribeId, amount) {
    let headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Content-Type': 'application/json'
    };

    if (window.subscribeChangeAvailable === true) {
        // sendSubscribe(subscribeId);
        redirect(amount);
    } else {
        redirect(amount);
    }

    async function sendSubscribe(subscribeId) {
        try {
            let response = await axios.post(`/subscribe/${subscribeId}`, {
                headers: headers
            });
            redirect(amount);
        } catch (event) {
            console.dir(event);
        }
    }

    async function redirect(amount) {
        try {
            let response = await axios.post(window.paymentRoute, {
                headers: headers,
                amount: amount,
                subscribe: subscribeId
            });

            window.location.href = response.data.url;
        } catch (event) {
            console.dir(event);
        }
    }
}
